import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";
import Home from "@/pages/Home";
import Picks from "@/pages/Picks";
import Results from "@/pages/Results";
import HowItWorks from "@/pages/HowItWorks";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPicks from "@/pages/admin/AdminPicks";
import AdminPickForm from "@/pages/admin/AdminPickForm";
import AdminResults from "@/pages/admin/AdminResults";
import AdminHistorical from "@/pages/admin/AdminHistorical";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PublicSite() {
  return (
    <>
      <Navbar />
      <main className="relative z-[2]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/picks" element={<Picks />} />
          <Route path="/results" element={<Results />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <MobileNav />
    </>
  );
}

function AdminSite() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="picks" element={<AdminPicks view="all" />} />
          <Route path="picks/new" element={<AdminPickForm />} />
          <Route path="picks/pending" element={<AdminPicks view="pending" />} />
          <Route path="picks/settled" element={<AdminPicks view="settled" />} />
          <Route path="picks/:id/edit" element={<AdminPickForm />} />
          <Route path="results" element={<AdminResults />} />
          <Route path="historical" element={<AdminHistorical />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#080A0F]">
      <div className="noise-overlay" aria-hidden="true" />
      <AuthProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/admin/*" element={<AdminSite />} />
            <Route path="/*" element={<PublicSite />} />
          </Routes>
          <Toaster position="top-center" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
